import { TicketingRecurrenceData } from "../types";

type VisibilityRecurrence = Pick<TicketingRecurrenceData, "id" | "isHidden" | "endUtc" | "repeatUntilDate">;

const getLastSellableDate = (recurrence: VisibilityRecurrence): Date | null => {
  const dates = [recurrence.endUtc, recurrence.repeatUntilDate].filter((date): date is Date => Boolean(date));
  return dates.length ? new Date(Math.max(...dates.map((date) => date.getTime()))) : null;
};

export const getOnlyUpcomingVisibleRecurrenceId = (
  recurrences: VisibilityRecurrence[] | undefined,
  now: Date
): string | null => {
  const upcomingVisibleRecurrences = (recurrences ?? []).filter((recurrence) => {
    const lastSellableDate = getLastSellableDate(recurrence);
    return !recurrence.isHidden && lastSellableDate !== null && lastSellableDate.getTime() > now.getTime();
  });

  const [onlyRecurrence] = upcomingVisibleRecurrences;
  return upcomingVisibleRecurrences.length === 1 ? onlyRecurrence.id : null;
};
